const education = [
  {
    period: '2013–2016',
    school: 'College of Arts Media and Technology, Chiang Mai University',
    schoolTh: 'มหาวิทยาลัยเชียงใหม่ - วิทยาลัยศิลปะ สื่อ และเทคโนโลยี',
    degree: "Bachelor's Degree — Software Engineering",
    degreeTh: 'ปริญญาตรี — วิศวกรรมซอฟต์แวร์',
  },
  {
    period: '2010–2013',
    school: 'Lampang Kanlayanee School',
    schoolTh: 'โรงเรียนลำปางกัลยาณี',
    degree: 'High School — Mathematics-Sciences',
    degreeTh: 'มัธยมศึกษา — คณิตศาสตร์-วิทยาศาสตร์',
  },
];

export default education;
